import React, { CSSProperties, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { isValid, parseISO } from 'date-fns';
import debounce from '@material-ui/core/utils/debounce';
import { SymbolDiv, VcGrid } from 'components/Grid';
import { dDaFormatP } from 'main_consts';
import { dateTypingChange } from 'main_func';
import { makeStyles } from '@material-ui/core';
import DatePickerTyping from './DatePickerTyping';
import { IupdateObj } from '.';
import { seDateVerify } from './consts';

interface IDateSePickersTyping {
  names: [string, string];
  required?: boolean;
  disabled?: boolean;
  mainClass?: string;
  verifyError?: boolean;
  data: unknown;
  updateData: (updateObj: IupdateObj) => void;
  style: CSSProperties;
  seInterval?: number;
}

const useStyles = makeStyles(() => ({
  errorText: {
    '& .MuiFormHelperText-root': { fontSize: '1em' },
  },
}));

const DateSePickersTyping = (props: IDateSePickersTyping): JSX.Element => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const {
    names,
    required = false,
    mainClass,
    verifyError,
    data: dataTemp,
    updateData,
    style = {},
    seInterval,
    disabled = false,
  } = props;

  const data = dataTemp as IupdateObj<string>;

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  useEffect(() => {
    const valueDate = [parseISO(data[names[0]]), parseISO(data[names[1]])].map(
      (obj) => (isValid(obj) ? obj : null)
    );

    setStartDate(valueDate[0]);
    setEndDate(valueDate[1]);

    const nullOrValid = (d: string | Date | null) => d === null || isValid(d);

    updateData({
      [`${names[0]}Valid`]: nullOrValid(valueDate[0]),
      [`${names[1]}Valid`]: nullOrValid(valueDate[1]),
    });
  }, [data[names[0]], data[names[1]]]);

  const Pickers = [
    <DatePickerTyping
      className={classes.errorText}
      disabled={disabled}
      required={required}
      verifyBeforeChange={verifyError}
      format={dDaFormatP}
      value={startDate}
      // maxDate={daFormatTrans(data[names[1]]) || undefined}
      onChange={(date) => {
        setStartDate(date);
        const name = names[0];
        dateTypingChange(updateData)(name)(date);
        if (isValid(date)) {
          const func = debounce(() =>
            seDateVerify(
              name,
              date,
              [names[0], names[1]],
              data,
              updateData,
              enqueueSnackbar,
              seInterval ? Math.abs(seInterval) : undefined
            )
          );
          func();
        }
      }}
    />,
    <DatePickerTyping
      className={classes.errorText}
      disabled={disabled}
      required={required}
      verifyBeforeChange={verifyError}
      format={dDaFormatP}
      value={endDate}
      minDate={parseISO(data[names[0]]) || undefined}
      onChange={(date) => {
        setEndDate(date);
        const name = names[1];
        dateTypingChange(updateData)(name)(date);
        if (isValid(date)) {
          const func = debounce(() =>
            seDateVerify(
              name,
              date,
              [names[0], names[1]],
              data,
              updateData,
              enqueueSnackbar,
              seInterval ? Math.abs(seInterval) : undefined
            )
          );
          func();
        }
      }}
    />,
  ];

  return (
    <VcGrid container className={mainClass} style={{ ...style, width: '100%' }}>
      <VcGrid item xs>
        {Pickers[0]}
      </VcGrid>
      <SymbolDiv />
      <VcGrid item xs>
        {Pickers[1]}
      </VcGrid>
    </VcGrid>
  );
};

export default DateSePickersTyping;
